import { parseApiResponse } from '~/schema/apiBoundary'

import { type RemoteStorageValues, RemoteStorageValuesSchema } from './schemas'

export const adaptRemoteStorageValues = (raw: unknown): RemoteStorageValues =>
  parseApiResponse(RemoteStorageValuesSchema, raw, 'RemoteStorage') ?? {}
